import { PLATFORM_LIST_DIV, elements } from '../resources';

import { getArticleID, getLoginUrl, getTemplate } from '../helpers';
import { getState } from '../core';
import * as actions from '../actions';

const { outerListContainer } = elements;

const renderListPage = async (init = false) => {
  const { pageType, sessionLoggedIn, bookmarkList, status } = getState();

  if (pageType !== 'list') return;
  if (!outerListContainer)
    throw `Could not find a container div with ${PLATFORM_LIST_DIV} `;

  if (init) {
    outerListContainer?.addEventListener('click', handleListpageClick);
    const { sessionLoggedIn } = getState();
    if (!sessionLoggedIn) return renderCopy();
    bookmarkList?.length && initializeList();
  }

  if (!sessionLoggedIn) return renderCopy();

  if (status === 'loading') return;

  bookmarkList?.length ? updateList() : renderCopy();
};

const updateList = () => {
  const { bookmarkList, status, listHasMoreTeasers } = getState();

  const ul = outerListContainer!.querySelector('.list-bookmarks');
  ul?.setAttribute('data-status', status || 'idle');

  let html = '';
  const length =
    ul?.querySelectorAll('.list-bookmarks .bookmark-teaser').length || 0;
  bookmarkList?.forEach((item, i) => {
    html += renderListItem(item, i + length + 1);
  });
  ul?.insertAdjacentHTML('beforeend', html);

  //toggle view state on button-load-more button if there are more teaserio's
  outerListContainer!
    .querySelector('.button-load-more')
    ?.classList.toggle('hidden', !listHasMoreTeasers);
};

const initializeList = () => {
  outerListContainer?.insertAdjacentHTML(
    'afterbegin',
    `
  <h1 class="title">Bewaarde artikelen</h1>
  <ul class="list-bookmarks" data-status="idle"></ul>
  <footer>
    <button class="button-load-more hidden" data-action-loadmore>Meer bewaarde artikelen</button>
    ${
      !!window.usabilla_live &&
      `<p class="feedback">Artikelen bewaren is een nieuwe functionaliteit.<button class="link" data-action-trigger-feedback>Laat feedback achter</button></p>`
    }
  </footer>
  `
  );
};

// with "copy" meaning static text as the page content.
const renderCopy = () => {
  const { sessionLoggedIn, brandName } = getState();
  let content;
  if (sessionLoggedIn) {
    content = getTemplate(brandName!, 'listPage', 'emptyList');
  } else if (!sessionLoggedIn) {
    content = getTemplate(brandName!, 'listPage', 'loggedOutCopy');
  }

  outerListContainer!.innerHTML = `<div class="bookmarking-content">${content}</div>`;
};

//use event delegation so we only have to set 1 listener on the list element.
const handleListpageClick = (e: Event) => {
  // only interested in Elements
  if (!(e.target instanceof HTMLElement)) return;

  if (e.target.closest('[data-action-remove]')) {
    const contentId = e.target.getAttribute('data-action-remove');
    actions.removeBookmark(contentId!);
    return;
  }

  if (e.target.closest('[data-action-login]')) {
    const { brandName } = getState();
    location.href = getLoginUrl(brandName!);
    return;
  }

  if (e.target.closest('[data-action-loadmore]')) {
    actions.loadMore();
    return;
  }

  if (e.target.closest('[data-action-trigger-feedback]')) {
    window.usabilla_live('click');
    return;
  }
};

const renderListItem = (teaser: BookmarkTeaser, position: number) => {
  const { externalUrl, images, label, paidContent, shortId, title } = teaser;

  // shortID for normal articles, externalUrl for KV articles.
  const idToRemove = shortId || externalUrl;

  // "Content id" for tracking
  const trackingId = getArticleID(false, idToRemove);

  const tracking = {
    contentId: `data-content_id=${trackingId}`,
    category: ` data-category="teaser"`,
    type: `data-type="article"`,
  };

  return `
    <li class="bookmark-teaser" data-position="${position}">
      <div class="bookmark-teaser-container">
        <div class="teaser-content">
          <a class="teaser__link" aria-label="${title}" href="${externalUrl}" ${
    tracking.contentId
  } ${tracking.category} ${tracking.type}>
           ${renderThumbnail(images)}
          </a>
          <header class="teaser__header">
          ${
            label
              ? `<h4 class="teaser__subtitle"><span class="teaser__label">${label}</span></h4>`
              : ''
          }
            <div class="teaser-list-item__body">
              <a class="teaser__title-wrapper" aria-label="${title}" href="${externalUrl}" ${
    tracking.contentId
  } ${tracking.category} ${tracking.type}>
                  <h3 class="teaser__title" data-teaser-title>${title}</h3>${
    paidContent ? '&nbsp;<span class="teaser__label--plus">Plus</span>' : ''
  }
              </a>
              <button class="button-remove button-mobile" data-action-remove="${idToRemove}" ${
    tracking.contentId
  }>Verwijder</button>
            </div>
            </header>
          <button class="button-remove button-desktop" data-action-remove="${idToRemove}" ${
    tracking.contentId
  }>Verwijder</button>
        </div>
        <hr class="divider">
    </div>
  </li>`;
};

const renderThumbnail = (images: TeaserImage[]) => {
  const { brandName } = getState();

  // for volkskrant, the placeholder is 'vk'.
  const prefix = brandName === 'volkskrant' ? 'vk' : brandName;

  const placeholderURL = `https://sel-static.acc.persgroep.net/shared/images/${prefix}-placeholder.png`;
  const onErrorAttribute = `onerror="this.src='${placeholderURL}'"`;

  let sources = '';
  let fallback = `<img class="thumbnail" src="${placeholderURL}" height="80px" width="80px"/>`;

  images.forEach((imageProps) => {
    const { imageSource, width, height } = imageProps;
    if (imageSource) {
      sources += `<source src="${imageSource}" ${onErrorAttribute}/>`;
      fallback = `<img class="thumbnail" src="${imageSource}" height="${height}" width="${width}" ${onErrorAttribute}/>`;
    }
  });

  return `
  <picture>
    ${sources}
    ${fallback}
  </picture>`;
};

export { renderListPage };
